import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BrandingData, HomePageData } from 'globals/store/publish.data';
import { Dictionary } from '@ngrx/entity';
import { Performer } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { JoiFile } from 'globals/store/files.model';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { BrandingTextBlockComponent } from './branding-text-block.component';
import { PerformerGalleryComponent } from 'src/app/modules/performers/performer-gallery.component';
import { SponsorGalleryCardComponent } from '../cards/sponsor-gallery-card.component';
import { SliderImagesComponent } from './slider-images.component';
import { CallsToActionComponent } from './branding-ctas.component';
import { CommonModule } from '@angular/common';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'home-page',
    template: `
<branding-text-block *ngIf="!!homePageData?.headerText" [brandingText]="homePageData.headerText"></branding-text-block>

<calls-to-action *ngIf="!isApp && !!callsToAction?.length" [ctas]="callsToAction"
  [style.--primary]="brandingData?.template.primary"
  [style.--primaryhover]="brandingData?.template.primaryhover"
></calls-to-action>

<branding-text-block *ngIf="!!homePageData?.bodyText" [brandingText]="homePageData.bodyText"></branding-text-block>
 
<ng-container *ngIf="!isApp">
  <ng-container *ngIf="(homePageData?.performerIds || []) | idsToItems:performers as performerList">
    <h4 class="title" *ngIf="!!performerList.length">{{ tabNames['performersTab'] || defaultTabNames['performersTab'] }}</h4>
    <performer-gallery *ngIf="!!performerList.length" [performerList]="performerList" ></performer-gallery>
  </ng-container>

  <ng-container *ngIf="(homePageData?.sponsorIds || []) | idsToItems:sponsors as sponsorList">
    <h4 class="title" *ngIf="!!sponsorList.length">{{ tabNames['sponsorsTab'] || defaultTabNames['sponsorsTab'] }}</h4>
    <div class="sponsors-holder" *ngIf="!!sponsorList.length">
      <sponsor-gallery-card *ngFor="let sponsor of sponsorList" [sponsor]="sponsor"></sponsor-gallery-card>
    </div>
  </ng-container>
  <ng-container *ngIf="(homePageData?.exhibitorIds || []) | idsToItems:exhibitors as exhibitorList">
    <h4 class="title" *ngIf="!!exhibitorList.length">{{ tabNames['exhibitorsTab'] || defaultTabNames['exhibitorsTab'] }}</h4>
    <div class="sponsors-holder" *ngIf="!!exhibitorList.length">
      <sponsor-gallery-card *ngFor="let exhibitor of exhibitorList" [showName]="true" [sponsor]="exhibitor"></sponsor-gallery-card>
    </div>
  </ng-container>
  <branding-text-block *ngIf="!!homePageData?.textBlock" [brandingText]="homePageData?.textBlock"></branding-text-block>
</ng-container>

<slider-images *ngIf="!!homePageData?.sliderImages?.length" [sliderImages]="homePageData.sliderImages"></slider-images>

`,
    styleUrls: ['./home-page.scss'],
    standalone: true,
    imports: [BrandingTextBlockComponent, CommonModule, IdsToItemsPipe, PerformerGalleryComponent, SponsorGalleryCardComponent, SliderImagesComponent, CallsToActionComponent],
})
export class HomePageComponent {
  @Input() homePageData: HomePageData
  @Input() brandingData: BrandingData
  @Input() performers: Dictionary<Performer>
  @Input() sponsors: Dictionary<Sponsor>
  @Input() exhibitors: Dictionary<Exhibitor>
  @Input() callsToAction: JoiFile[]
  @Input() tabNames: { [tId: string]: string } = {}
  @Input() isApp
  defaultTabNames:{ [tId: string]: string } = getDefaultProgramTabNames() 
}